<template>
  <EventsListWithFiltersWrapper
    :title="$t('events.upcoming_events')"
    :event-type="EventType.Default"
    :list-type="
      authStore.auth ? EventsListTypeMap.MeUpcoming : EventsListTypeMap.Upcoming
    "
  >
    <template #empty>
      <div class="py-4">
        <template v-if="eventsStore.filtersCount > 0">
          {{ $t('events.no_events_with_filters') }}
        </template>
        <template v-else>
          {{ $t('events.no_events') }}
        </template>
      </div>
    </template>
  </EventsListWithFiltersWrapper>
</template>

<script setup lang="ts">
import { useAuth } from '~/stores/auth'
import { useEvents } from '~/stores/events'
import { EventType, EventsListTypeMap } from '~/models/events'

definePageMeta({
  alias: ['/events'],
})

const authStore = useAuth()
const eventsStore = useEvents()

useHeadMeta(
  {
    title: 'Upcoming WN events',
    description:
      'Game industry conferences, networking events, and summits around the world, including UK, China, Turkey, US, Canada, and EU',
  },
  { canonical: 'https://wnhub.io/event-info' }
)
</script>
